import { createFileRoute, Outlet } from "@tanstack/react-router";
export const Route = createFileRoute("/_site/gift-cards")({ component: GiftCardLayout });
function GiftCardLayout() { return <Outlet />; }
